import _objectSpread from "@babel/runtime-corejs2/helpers/esm/objectSpread";
import { trackEventActions, trackPageViewActions } from './utils/trackerEvents';
/**
 * Simple redux middleware to use redux actions as input of tracking!
 * this will call the track function from the provided instance of tracker on every action
 * and use the action type as the event type and the action payload as the event data
 * @param {Object} tracker
 */

export var trackingMiddleware = function trackingMiddleware(tracker) {
  return function () {
    return function (next) {
      return function (action) {
        if (tracker && tracker.instance) {
          var pageViewActions = tracker.pageViewActions,
              eventActions = tracker.eventActions;
          var type = action.type,
              data = action.data;

          if (pageViewActions && pageViewActions.includes(type)) {
            trackPageViewActions(_objectSpread({}, data));
          }

          if (eventActions && eventActions.includes(type)) {
            trackEventActions(_objectSpread({}, data));
          }
        }

        next(action);
      };
    };
  };
};
export default trackingMiddleware;